import fingoMuiLink, { underlineTabLink } from '../../fingo/components/MuiLink';
import { NAVBAR_LINK_CLASS_NAME, NAVBAR_PROFILE_CLASS_NAME, TAB_LINK_CLASS_NAME, DEFAULT_LINK_CLASS_NAME, PRIMARY_LINK_CLASS_NAME, NAVBAR_ROUTE_CLASS_NAME } from '../../constants/link';

const navbarLink = ({ theme }) => ({
  color: theme.palette.primary.A300,
  fontWeight: 500,
  fontSize: theme.typography.small_3.fontSize,
  textTransform: 'uppercase',
  textDecorationLine: 'underline',
  textDecorationStyle: 'solid',
  textDecorationColor: theme.palette.primary.A300,
  textDecorationSkipInk: 'auto',
  textDecorationThickness: 'auto',
  textUnderlineOffset: 'auto',
  textUnderlinePosition: 'from-font',
  '&:hover': {
    textDecorationColor: theme.palette.secondary.A400,
    color: theme.palette.secondary.A400,
  },
});

const navbarProfileLink = ({ theme }) => ({
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.main,
  border: `1px solid ${theme.palette.secondary.A400}`,
  borderRadius: 20,
  padding: 8,
  fontWeight: 500,
  fontSize: theme.typography.small_3.fontSize,
  textDecoration: 'none',
  cursor: 'pointer',
});

const defaultLink = ({ theme }) => ({
  color: theme.palette.secondary.A400,
});

const primaryLink = ({ theme }) => ({
  color: theme.palette.primary.A400,
  textDecorationLine: 'underline',

});

const navbarRoute = ({ theme }) => ({
  color: 'white',
  ...theme.typography.medium_2,
  fontWeight: 600,
  '&:hover': {
    color: theme.palette.secondary.A400,
    textDecoration: 'none',
  },
  '&.active': {
    color: theme.palette.secondary.A400,
    textDecoration: 'underline',
  },
  textDecoration: 'none',
  whiteSpace: 'nowrap',
});

const MuiLink = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...fingoMuiLink.styleOverrides.root({ theme }),
      [`&.${NAVBAR_LINK_CLASS_NAME}`]: navbarLink({ theme }),
      [`&.${NAVBAR_PROFILE_CLASS_NAME}`]: navbarProfileLink({ theme }),
      [`&.${TAB_LINK_CLASS_NAME}`]: underlineTabLink({ theme, accentColor: theme.palette.secondary.A500 }),
      [`&.${DEFAULT_LINK_CLASS_NAME}`]: defaultLink({ theme }),
      [`&.${PRIMARY_LINK_CLASS_NAME}`]: primaryLink({ theme }),
      [`&.${NAVBAR_ROUTE_CLASS_NAME}`]: navbarRoute({ theme }),
    }),
  },
};

export default MuiLink;
